import { useEffect, useState } from "react";
import api from "../../utils/api";
import toast from "react-hot-toast";

export default function CreateUser() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    roles: [],
  });

  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchRoles();
  }, []);

  const fetchRoles = async () => {
    try {
      const res = await api.get("/admin/roles");
      console.log(res.data); 
      setRoles(res.data);
    } catch {
      toast.error("Failed to load roles");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleRoleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      roles: [e.target.value],
    }));
  };

  const validate = () => {
    if (!form.name.trim()) return "Name required";
    if (!form.email.trim()) return "Email required";
    if (!form.password.trim()) return "Password required";
    if (form.roles.length === 0) return "Role required";
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const error = validate();

    if (error) {
      toast.error(error);
      return;
    }

    try {
      setLoading(true);

      await api.post("/users", form);

      toast.success("User created");

      setForm({
        name: "",
        email: "",
        password: "",
        roles: [],
      });
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-xl mx-auto bg-white rounded-xl shadow p-6">
      <h2 className="text-2xl font-semibold mb-6">Create User</h2>

      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          name="name"
          placeholder="Full Name"
          className="w-full border rounded-lg p-3"
          value={form.name}
          onChange={handleChange}
        />

        <input
          name="email"
          type="email"
          placeholder="Email"
          className="w-full border rounded-lg p-3"
          value={form.email}
          onChange={handleChange}
        />

        <input
          name="password"
          type="password"
          placeholder="Password"
          className="w-full border rounded-lg p-3"
          value={form.password}
          onChange={handleChange}
        />

        <select
          className="w-full border rounded-lg p-3"
          value={form.roles[0] || ""}
          onChange={handleRoleChange}
        >
          <option value="">Select Role</option>
          {roles.map((role) => (
            <option key={role.id} value={role.id}>
              {role.name}
            </option>
          ))}
        </select>

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-600 text-white rounded-lg p-3"
        >
          {loading ? "Creating..." : "Create User"}
        </button>
      </form>
    </div>
  );
}